import { render, staticRenderFns } from "./promotion-resources.vue?vue&type=template&id=dc86b1f8&scoped=true"
import script from "./promotion-resources.vue?vue&type=script&lang=js"
export * from "./promotion-resources.vue?vue&type=script&lang=js"
import style0 from "./promotion-resources.vue?vue&type=style&index=0&id=dc86b1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc86b1f8",
  null
  
)

export default component.exports